import React from 'react'

import * as css from './MantenedorDistancias.css'

let PropTypes = React.PropTypes

export class RowDistancias extends React.Component{
    constructor(props){
        super(props)
        this.inputOnKeyDown = this.inputOnKeyDown.bind(this)
        this.state = {
            inputDistancia: [{valor: '',origen: '', destino: ''}]
        }
        this.onInputChange=(index, evt)=>{
            console.log(index)
            let inputDistancia = this.state.inputDistancia
            inputDistancia.destinos[index].valor = evt.target.value
            inputDistancia.destinos[index].dirty = 1
            inputDistancia.dirty = 1
            this.setState({
                inputDistancia
            })
        }
        this.onBlurInput=(index)=>{
            if(this.state.inputDistancia.destinos[index].dirty)  
                this.context.guardaDestino(this.state.inputDistancia.destinos[index].idComunaDistancia, this.props.comunaRow.cutComuna, this.state.inputDistancia.destinos[index].idComunaDestino, this.state.inputDistancia.destinos[index].valor)
        }
    }
    focusElemento(elemento){
        this[elemento].focus()
    }
    inputOnKeyDown(key, evt){
        console.log("enter")
        if((evt.keyCode===9 && evt.shiftKey===false) || evt.keyCode===40 || evt.keyCode===13){
            // 9 = tab, flechaAbajo = 40,  13 = enter
            evt.preventDefault()
            //this.props.focusRow(this.props.index+1, key)

        }else if((evt.keyCode===9 && evt.shiftKey===true) || evt.keyCode===38) {
            // flechaArriba = 38, shift+tab
            evt.preventDefault()
            //this.props.focusRow(this.props.index-1, key)
        }
    }
    componentWillMount(){
        this.setState({
            inputDistancia: this.props.comunaRow
        })
    }
    componentWillReceiveProps(nextProps){
        this.setState({
            inputDistancia: nextProps.comunaRow
        })
    }
    render() {
        return (
            <tr key={this.props.index}>
                {/* index */}
                <td className={css.tdIndex} title={this.props.comunaRow.cutComuna}>{this.props.index+1}</td>
                {/* Comuna */}
                <td className={css.tdComuna}>{this.props.comunaRow.nombre}</td>
                {this.state.inputDistancia != []? _.range(0, this.state.inputDistancia.destinos.length).map(index=>{
                    return <td key={index}>
                        <input type="number" className="form-control"
                            placeholder={this.props.comunaRow.nombre+"-"+this.state.inputDistancia.destinos[index].nombreDestino}
                            title={this.props.comunaRow.nombre+"-"+this.state.inputDistancia.destinos[index].nombreDestino}
                            ref={(valor) => { this.inputValor = valor }}
                            onChange={this.onInputChange.bind(this, index)}
                            onBlur={this.onBlurInput.bind(this, index)}
                            value={this.state.inputDistancia.destinos[index].valor === 0? '' : this.state.inputDistancia.destinos[index].valor }/>
                    </td>
                }):null}
            </tr>
        )
    }
}
RowDistancias.contextTypes = {
    guardaDestino: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/admin/distancias/RowDistancias.jsx